// ═══════════════════════════════════════════════════════════════════════════
// QAPAQ SpA — Roles
//
// Existe porque `admin_flota` significaba dos cosas incompatibles: el jefe de
// flota de una empresa de transporte —que es un CLIENTE— y el operador de
// QAPAQ. Y el rol se elegía libremente en el registro.
//
// Consecuencia: cualquiera que se registrara como jefe de flota quedaba con
// acceso a la contabilidad de QAPAQ, al CRM y a las solicitudes de datos
// personales de todos los demás usuarios.
//
// Los predicados viven acá y no repartidos por las pantallas justamente por
// eso: una convención repartida deriva, y esa deriva fue el origen de seis
// bugs en un solo día. Si mañana aparece otro rol, se agrega en un archivo.
// ═══════════════════════════════════════════════════════════════════════════

export const ROL = {
  OFERENTE:    'oferente',
  CHOFER:      'chofer',
  ADMIN_FLOTA: 'admin_flota',
  BODEGUERO:   'bodeguero',
  SUPERADMIN:  'superadmin',
}

/**
 * Los roles que una persona puede elegir al registrarse.
 *
 * `superadmin` NO está y no puede estar: se otorga sólo desde la base con
 * `service_role`. Si alguna vez aparece en esta lista, cualquiera puede
 * darse acceso a la operación completa de QAPAQ desde el formulario de
 * registro. La base lo impide igual —la política de INSERT lo valida— pero
 * esta lista es la primera barrera y la que se lee.
 */
export const ROLES_AUTOSERVICIO = [ROL.OFERENTE, ROL.CHOFER, ROL.ADMIN_FLOTA]

/** Lado de la oferta: cotiza, transporta, maneja vehículos. */
export const esTransportista = (u) =>
  u?.rol === ROL.CHOFER || u?.rol === ROL.ADMIN_FLOTA

/** Cliente que administra una flota: sus vehículos, sus choferes, su GPS. */
export const esJefeDeFlota = (u) => u?.rol === ROL.ADMIN_FLOTA

/**
 * Operador de QAPAQ. Finanzas, DTE, cumplimiento, CRM, métricas del negocio.
 *
 * No es «un admin_flota con más permisos»: es otra cosa. Un jefe de flota es
 * un cliente y no tiene por qué ver el GMV de la plataforma ni las solicitudes
 * ARCO de terceros.
 */
export const esOperadorQapaq = (u) => u?.rol === ROL.SUPERADMIN

/** Etiqueta legible para la UI. */
export const etiquetaRol = (rol) => ({
  [ROL.OFERENTE]:    '📦 Oferente',
  [ROL.CHOFER]:      '🚚 Transportista',
  [ROL.ADMIN_FLOTA]: '🚛 Jefe de flota',
  [ROL.BODEGUERO]:   '🏭 Bodeguero',
  [ROL.SUPERADMIN]:  '⚙️ Operador QAPAQ',
}[rol] || rol)
